import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    this.dispatchNativeChange = this.dispatchNativeChange.bind(this);
  }

  connect() {
    // Tokenfields live inside Turbo-powered forms and can reconnect frequently;
    // only initialize when Select2 hasn't already decorated the element.
    this.initializeSelect2();
  }

  disconnect() {
    // Leave the original <select> intact for Turbo's cache/back-button behavior.
    this.destroySelect2();
  }

  initializeSelect2() {
    if (this.isSelect2Initialized()) return;

    // Cached DOM may still have the previous Select2 markup; strip it so the new
    // instance doesn't inherit a broken wrapper.
    this.removeStaleSelect2Artifacts();

    $(this.element).select2({
      tags: true,
      tokenSeparators: [";"],
      matcher: this.matchCustom,
      language: {
        noResults: function () {
          return "Start typing...";
        },
      },
      templateResult: (item) => {
        if (item.loading || item.id === "") {
          return item.text;
        }
        return "Enter to add: " + item.text;
      },
    });

    // Mirror Select2 events to native change events for Rails form helpers.
    $(this.element).on("select2:select select2:unselect", this.dispatchNativeChange);
  }

  destroySelect2() {
    if (!this.isSelect2Initialized()) return;

    $(this.element).off("select2:select select2:unselect", this.dispatchNativeChange);
    $(this.element).select2("destroy");
  }

  dispatchNativeChange() {
    const event = new Event("change", { bubbles: true });
    this.element.dispatchEvent(event);
  }

  matchCustom() {
    return null;
  }

  isSelect2Initialized() {
    return Boolean($(this.element).data("select2"));
  }

  removeStaleSelect2Artifacts() {
    // Remove any stray Select2 DOM/classes left over from a cached page snapshot.
    const sibling = this.element.nextElementSibling;
    if (sibling && sibling.classList?.contains("select2")) {
      sibling.remove();
    }
    this.element.classList.remove("select2-hidden-accessible");
    this.element.removeAttribute("data-select2-id");
    $(this.element).off(".select2");
  }

}
